import { render } from "./MultiSelectControl.vue?vue&type=template&id=067a14d3"
import script from "./MultiSelectControl.vue?vue&type=script&lang=js"
export * from "./MultiSelectControl.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mior/Projects/laravel/nova/silver-surfer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MultiSelectControl.vue"]])

export default __exports__